import { useEffect, useState } from "react";
import Image from "next/image";
import styles from "./CareerBanner.module.css";
import usePopupVisibility from "../PopupForm/usePopupVisibility";
import PopupForm from "../PopupForm/PopupForm";

interface ImageData {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string | null;
}

interface CmsData {
  id: number;
  title: string;
  description: string;
  desktop_img: ImageData;
  mobile_img: ImageData;
}

interface BannerCommonProps {
  data?: any;
  cmsData?: CmsData;
  className?: string;
  classValue?: string;
  careerPage?: any;
}

const BannerCommon: React.FC<BannerCommonProps> = ({
  data,
  cmsData,
  className,
  classValue,
  careerPage,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const { isPopupVisible, showPopup, hidePopup } = usePopupVisibility();

  useEffect(() => {
    // Ensure this runs only on the client side (browser)
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const bannerHeight = isMobile
    ? data.MobileBannerHeight
    : data.DesktopBannerHeight;

  return (
    <section className={styles.heroVideo}>
      {isPopupVisible && (
        <PopupForm
          isVisible={isPopupVisible}
          onClose={hidePopup}
          careerPopup
          popUpData={careerPage?.pop_up_front_section}
        />
      )}

      <div
        className={`${styles.BannerContainer} ${
          className ? styles.aboutBannerClass : ""
        } ${classValue ? styles.contactBannerClass : ""}`}
        style={{ height: `${bannerHeight}px` }}
      >
        <Image
          src={
            isMobile
              ? cmsData?.mobile_img?.url || ""
              : cmsData?.desktop_img?.url || ""
          }
          alt={
            isMobile
              ? cmsData?.mobile_img?.alternativeText || ""
              : cmsData?.desktop_img?.alternativeText || ""
          }
          fill
          style={{
            objectFit: "cover",
          }}
          className={styles.Banner}
          priority
        />
        <div className={styles.overlay}></div>
        <div className={styles.callout}>
          {cmsData?.title && <h1>{cmsData.title}</h1>}
          {cmsData?.description && (
            <div className={styles.desc}>{cmsData.description}</div>
          )}
          <div className={styles.mobileApply}>
            <button className={styles.button} onClick={showPopup}>
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerCommon;
